
import { ReactNode } from "react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  footerText?: string;
  footerLink?: {
    text: string;
    href: string;
  };
}

const AuthLayout = ({ 
  children, 
  title, 
  subtitle,
  footerText,
  footerLink
}: AuthLayoutProps) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <Link to="https://recallio.ai/">
            <img 
              src="/lovable-uploads/4eecbb54-a517-42eb-bf2a-f06ad5d82aee.png" 
              alt="Recallio Logo" 
              className="h-auto w-[100px] mx-auto"
            />
          </Link>
        </div>
        
        <Card className="border-border shadow-lg">
          <CardHeader className="space-y-1 text-center">
            <h2 className="text-2xl font-semibold">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </CardHeader>
          
          <CardContent>
            {children}
          </CardContent>
          
          {(footerText || footerLink) && (
            <CardFooter className="flex-col items-center border-t px-6 py-4">
              <div className="text-sm text-muted-foreground">
                {footerText} {footerLink && (
                  <Link 
                    to={footerLink.href}
                    className="font-medium text-primary hover:underline"
                  >
                    {footerLink.text}
                  </Link>
                )}
              </div>
            </CardFooter>
          )}
        </Card>
      </div>
    </div>
  );
};

export default AuthLayout;
